import PropTypes from 'prop-types';
import React from 'react';
import {Row} from 'react-bootstrap';
import Navbar from '../navigation/navbar';
import LeftSide from '../main/left-side';
import RightSide from '../main/right-side';
import TitleCard from '../main/title-card';
import translate from '../translate';
import {Outlet} from 'react-router-dom';

class PasswordResetWrapper extends React.Component {
    static propTypes = {
        strings: PropTypes.object,
        location: PropTypes.object,
        children: PropTypes.node,
    };

    render() {
        return (
            <Navbar nav={false}>
                <Row>
                    <LeftSide>
                        <TitleCard title={this.props.strings.title} />
                    </LeftSide>
                    <Outlet />
                    <RightSide></RightSide>
                </Row>
            </Navbar>
        );
    }
}

export default translate('PasswordResetWrapper')(PasswordResetWrapper);
